<template>
	<div>
		<CubePage type="myorder-view" title="产品编辑" backurl="supplier_product">
			<div slot="content" class="content">
				<div class="shopxq leopages" v-if="dataObj != null">
					<div class="list-box">
						<div class="list-item">
							<div class="item-card">
								<van-image class="card-img" radius="10" :src="dataObj.images" />
								<div class="card-content">
									<div class="conten-title">
										<p class="t ells2">{{dataObj.goods_name}}</p>
									</div>
									<div class="conten-desc">
										<p>实际销量:{{dataObj.sales_actual}}</p>
										<p class="desc-red">
											￥
											<span>{{dataObj.goods_min_price}}</span>
											起
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<van-form @submit="onSubmit">
						<van-field name="row[goods_name]" label="产品名称"
						v-model="dataObj.goods_name" placeholder="产品名称"
						autosize row="2" type="textarea" maxlength="35"/>
						<van-field name="meta[distribution]" label="分销销售">
							<template #input>
								<van-radio-group v-model="dataObj.distribution" direction="horizontal">
									<van-radio name="10">是</van-radio>
									<van-radio name="20">否</van-radio>
								</van-radio-group>
							</template>
						</van-field>
						<van-field name="meta[retail]" label="小店销售">
							<template #input>
								<van-radio-group v-model="dataObj.retail" direction="horizontal">
									<van-radio name="10">是</van-radio>
									<van-radio name="20">否</van-radio>
								</van-radio-group>
							</template>
						</van-field>
						<van-field name="meta[order_taking]" label="自动接单">
							<template #input>
								<van-radio-group v-model="dataObj.order_taking" direction="horizontal">
									<van-radio name="10">是</van-radio>
									<van-radio name="20">否</van-radio>
								</van-radio-group>
							</template>
						</van-field>
						<van-field name="meta[advance_day]" label="预售(天)" v-model="dataObj.advance_day" placeholder="预售(天)" />
						<van-field name="meta[delay_pay]" label="延迟支付" v-model="dataObj.delay_pay"
							placeholder="延迟支付(分钟)" />
						<van-field name="meta[refund_rule]" label="退款规则">
							<template #input>
								<van-radio-group v-model="dataObj.refund_rule" direction="horizontal">
									<van-radio name="10">直接退</van-radio>
									<van-radio name="20">不可退</van-radio>
									<van-radio name="30">审核退</van-radio>
								</van-radio-group>
							</template>
						</van-field>
						<div class="van-goods-action">
							<div class="van-goods-action-icon" style="flex: 1; font-size: 1em;"
							 @click="onshowPop">
<!--								<van-icon name="eye-o" />-->
								<span>价格/库存管理</span>
							</div>
							<van-button style="flex: 1;" round block type="primary" native-type="submit">提交</van-button>
						</div>
					</van-form>
				</div>
			</div>
		</CubePage>
		<van-popup class="sku-pop" v-model="show" position="right" :round="true" :safe-area-inset-bottom="true"
			closeable style="width: 80%;height: 100%;">
			<h3 class="title" style="text-align: center;">sku列表</h3>
			<div class="skulist">
				<div class="skuitem" v-if="skuList != null || skuList.length >0" v-for="item in skuList"
					:key="item.spec_sku_id">
					<p class="skuname">{{item.sku_name}}</p>
					<span class="sku-flex">
						<div class="nums">
							<p>今日底价: <span>{{item.floor_price}}</span></p>
						</div>
						<van-button type="primary" size="mini" @click="goSku(item)">编辑</van-button>
					</span>
				</div>
				<p v-else>暂无数据</p>
			</div>
		</van-popup>

	</div>
</template>

<script>
	import CubePage from '../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import {
		Dialog,
		Toast
	} from 'vant';
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				show: false,
				entry: {},
				dataObj: null,
				goodsId: null,
				skuList: null,
				swObj: null
			}
		},
		created() {
			let id = this.$route.params.id ? this.$route.params.id : this.$store.getters.getsupID
			console.log(id)
			// this.entry = en
			this.goodsId = id
			this.getData(id)
		},
		methods: {
			async getData(id) {
				let that = this
				var url = "/addons/litestore/api.supplier/productEdit"
				await util.get(url, {
						id: id
					},
					function(res) {
						that.dataObj = res.data
					});
			},
			onshowPop() {
				this.getSkuDatas()
				this.show = true
			},
			async getSkuDatas() {
				let that = this
				var url = "/addons/litestore/api.supplier/getProductSkus"
				await util.post(url, {
						id: that.goodsId
					},
					function(res) {
						console.log(res)
						that.skuList = res
					});
			},
			//sku
			goSku(obj) {
				let that = this;
				this.$store.commit('setsupSetObj', obj)
				this.$router.push({
					name: 'pEditSku',
					params: {
						entity: obj
					}
				})
			},
			async onSubmit(values) {

				console.log('tj', values)
				let that = this
				let prams=values
				prams.id=that.dataObj.goods_id
				var url = "/addons/litestore/api.supplier/productEdit"
				await util.post(url, prams,
					function(res) {
						console.log(res)
						Dialog.alert({
							title: '温馨提示',
							message: res.msg
						});
					});
			}
		}
	}
</script>
<style lang="less" scoped>
	.sku-pop {
		background-color: aliceblue;
		overflow: hidden;

		.title {
			line-height: 44px;
		}

		.skulist {
			height: calc(100vh - 60px);
			overflow-x: hidden;

			.skuitem {
				padding: 8px 16px;
				margin: 2px;
				background-color: #fff;
				box-sizing: border-box;

				.skuname {
					overflow: hidden;
					text-overflow: ellipsis;
					word-break: break-all;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					font-size: 14px;
				}

				.sku-flex {
					padding-top: 6px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					font-size: 12px;
				}
			}
		}
	}
</style>
<style type="text/css" lang="less">
	.van-form {
		background-color: #FFFFFF;
		padding: 20px 0;
	}

	.van-nav-bar {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
	}

	.van-hairline--bottom::after {
		border-bottom-width: 0px;
	}

	.height100 {
		height: 100vh;
	}

	.flex-column-center {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.vue-cropper {
		background: #000 !important;

		.cropper-view-box {
			outline: 1px solid #fff !important;
			outline-color: #fff !important;
		}
	}

	.footerB {
		background: #000 !important;
		padding: 10px 15px;
		width: 100%;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;

		.fitem {
			color: #FFFFFF;
			// width:50px;
		}
	}

	.list-box {
		.list-item {
			margin-bottom: 1px;
			background-color: #FFFFFF;

			.item-card {
				display: flex;
				padding: 10px 15px;
				border-bottom: 1px solid #eaeaea;
				box-sizing: border-box;

				.card-img {
					width: 80px;
					height: 80px;
					border-radius: 10px;
				}

				.card-content {
					flex: 1;
					flex-shrink: 0;
					width: 0;
					margin-left: 15px;

					.conten-title {
						display: flex;

						.t {
							// max-width: 238px;
							font-size: 16px;
							font-weight: 600;
						}

						.tip {
							margin-left: 15px;
							text-align: center;
							width: 45px;
							height: 20px;
							line-height: 20px;
							font-size: 12px;
							color: #FFFFFF;
							background-color: #55aa7f;
							border-radius: 5px;
						}
					}

					.conten-desc {
						margin-top: 10px;
						padding: 3px 0;
						display: flex;
						justify-content: space-between;
						align-items: center;

						p {
							color: #a3a3a3;
							font-size: 12px;
						}

						.desc-red {
							color: #ff0000;

							span {
								font-size: 18px;
							}
						}
					}
				}
			}

			.item-btns {
				height: 48px;
				display: flex;
				justify-content: space-around;
				align-items: center;

				.btn-item {

					.van-icon,
					.iconfont {
						vertical-align: middle;
						font-size: 18px;
					}

					.btn-text {
						font-size: 13px;
						padding: 0 5px;
					}
				}
			}
		}
	}
</style>
